import handleError from '@pcid/actions/handle-error';
import { getResetPasswordRelyingPartyStorage, getRelyingPartyStorage } from '@pcid/storage-utils';
import RequestBuilder from '@pcid/client-request-builder';
import { trackForgotPasswordEmail, trackGenericException } from '../track-analytics';

const forgotPasswordAction = ({ email, sourcePage = 'forgotPassword' } = {}) => new RequestBuilder()
	.withData({ email })
	.post('/forgot-password')
	.then(() => getResetPasswordRelyingPartyStorage().set(getRelyingPartyStorage().get()))
	.then(() => ({
		type: 'success',
		message: {
			id: 'form.forgotPassword.successMessage',
			values: { email },
		},
		sourcePage,
	}))
	.then(trackForgotPasswordEmail)
	.catch(handleError)
	.catch(trackGenericException);

export default forgotPasswordAction;
